module.exports = __webpack_public_path__ + "img/dire.f2dfec34.png";